

import { Component, Vue, Prop } from 'vue-property-decorator';
import RemoveUserButton from '~/components/User/RemoveUserButton.vue';
import { SearchModule } from '~/store/modules/search';
import { MappedOwner } from '~/interfaces/owners.interface';

@Component({
    components: {
        RemoveUserButton,
    },
})
export default class LinkedUser extends Vue {
    @Prop() linkedUser!: MappedOwner;
    @Prop() width!: number;

    navigateToUser(user: MappedOwner) {
        if (user.externalLinkPrefix) {
            window.location.href = `${user.externalLinkPrefix}/${user.link}`;
        } else {
            // prefix is owner + ://
            const prefix = user.owner ? user.owner + '://' : '';
            SearchModule.search({ searchText: user.mail, paramType: 'user_mail', prefix });
        }
    }
}
